import React from 'react';

import AdSDKContainer from '@wetransfer/transfer/adsdk';
import { FF_AD_SDK_2 } from '@wetransfer/transfer/constant/experiments';
import { getFullVariant } from '@wetransfer/transfer/modules/experiments';

import { ErrorBoundary } from './error-boundary';
import MicroFrontend from './micro-frontend';

const Wallpaper: React.FC = () => {
  const isAdSDK2Enabled = getFullVariant(FF_AD_SDK_2).value === 'on';

  if (isAdSDK2Enabled) {
    return <AdSDKContainer />;
  }

  return (
    <ErrorBoundary>
      <MicroFrontend />
    </ErrorBoundary>
  );
};

export default Wallpaper;
